var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.62492 4.87501H7.37492C7.44908 4.875 7.52156 4.853 7.58322 4.81179C7.64487 4.77058 7.69292 4.71202 7.7213 4.64351C7.74968 4.575 7.7571 4.49961 7.74264 4.42688C7.72818 4.35414 7.69247 4.28733 7.64005 4.23489L4.26505 0.859888C4.23024 0.825051 4.18891 0.797416 4.14342 0.77856C4.09793 0.759705 4.04916 0.75 3.99992 0.75C3.95068 0.75 3.90191 0.759705 3.85642 0.77856C3.81093 0.797416 3.7696 0.825051 3.7348 0.859888L0.359795 4.23489C0.307367 4.28733 0.271664 4.35414 0.257201 4.42688C0.242738 4.49961 0.250165 4.575 0.278541 4.64351C0.306917 4.71202 0.354969 4.77058 0.416623 4.81179C0.478277 4.853 0.550764 4.875 0.62492 4.87501Z",
    fill: "#67737E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort_up.248ce1ad543c02cf89b68dd8669289b4.svg";
export { ForwardRef as ReactComponent };